import axios from 'axios';

export function sendScreenSummaryReport(token, date = null) {
    const body = date ? { date } : {};
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/reports/screen-summary/send`,
        body,
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
